import { arraySchema, idSchema, enumSchema, numberSchema, stringSchema, objectSchema, dateTimeSchema } from '@/schemas'
import { EventBillingTypeEnum, EventStatusEnum, EventVisitTypeEnum } from '@/types'
import { isLessThanPeriod } from '@/utils'

export const calendarSchema = objectSchema({
  start_at: dateTimeSchema,
  end_at: dateTimeSchema,
  location_id: numberSchema.optional(),
  patient_id: idSchema,
  bill_type: enumSchema(Object.values(EventBillingTypeEnum)),
  visit_type: enumSchema(Object.values(EventVisitTypeEnum)),
  status: enumSchema(Object.values(EventStatusEnum)),
  participants: arraySchema(stringSchema).optional(),
}).refine(data => !isLessThanPeriod(data.end_at, data.start_at, 0), {
  message: 'End date must be greater than start date',
  path: ['end_at'],
})
